import { Routes, Route } from 'react-router-dom';
import Layout from './Layout';

import App from './App';
import ApiProductList from './ProductCategory/ApiProductList';
import CosmaticsandPersonalCareProducts from './ProductCategory/Cosmatics and Personal care products';
import ExcipientsList from './ProductCategory/Excipients List';
import InorganicChemicalsList from './ProductCategory/Inorganic Chemicals List';
import IntermediatesList from './ProductCategory/Intermediates List';
import OrganicChemicalsList from './ProductCategory/organic chemicals List';
import PharmaAndFoodGradeOils from './ProductCategory/Pharma & Food Grade Oils';
import WaterTreatmentMining from './ProductCategory/Water Treatment Mining';
import FlavourFragrance from './ProductCategory/FlavourAndFragrance';
import AboutUs from './AboutUs';
import Contact from './ContactUs';
import SearchResults from './SearchResults';
import ProductDetail from './ProductDetail';
import ScrollToTop from './ScrollToTop'; // scroll restoration
import Companyoverview from "./CompanyOverview";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsAndcondition from "./Terms&Conditions";
import Gallery from "./Gallery";
import LatestUpdate from "./LatestUpdates";
import BlogsAndArticles from "./Blogs&Articles";
import TawkToWidget from "./TawkToWidget";

function RoutingFile() {
    return (
        <>
            <TawkToWidget />
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<App />} />
                    <Route path="ApiProductList" element={<ApiProductList />} />
                    <Route path="CosmaticsandPersonalCareProducts" element={<CosmaticsandPersonalCareProducts />} />
                    <Route path="ExcipientsList" element={<ExcipientsList />} />
                    <Route path="InorganicChemicalsList" element={<InorganicChemicalsList />} />
                    <Route path="IntermediatesList" element={<IntermediatesList />} />
                    <Route path="OrganicChemicalsList" element={<OrganicChemicalsList />} />
                    <Route path="PharmaAndFoodGradeOils" element={<PharmaAndFoodGradeOils />} />
                    <Route path="WaterTreatmentMining" element={<WaterTreatmentMining />} />
                    <Route path="FlavourFragrance" element={<FlavourFragrance />} />
                    <Route path="AboutUs" element={<AboutUs />} />
                    <Route path="Contact" element={<Contact />} />
                    <Route path="search" element={<SearchResults />} />

                    {/* ✅ Updated route with slug */}
                    <Route path="product/:slug" element={<ProductDetail />} />

                    <Route path="Companyoveriew" element={<Companyoverview />} />
                    <Route path="TermsAndcondition" element={<TermsAndcondition />} />
                    <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
                    <Route path="Gallery" element={<Gallery />} />
                    <Route path="LatestUpdate" element={<LatestUpdate />} />
                    <Route path="BlogsAndArticles" element={<BlogsAndArticles />} />
                </Route>
            </Routes>
        </>
    );
}

export default RoutingFile;
